import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CommunicationHeader = () => {
  const { data, actions } = useCommunicationDetailsPage();

  return (
    <div className="cm-header">
      <h4 className="cm-header__title">{data.communication?.subject}</h4>
      <div className="cm-header__actions">
        <button
          type="button"
          className="cm-header__action-btn"
          onClick={actions.handleOpenCertification}
        >
          <em className="icon ni ni-shield-check" />
        </button>
        {!data.isReadOnly && (
          <button
            type="button"
            className="cm-header__action-btn"
            onClick={actions.handleToggleFavorite}
          >
            {data.communication?.isFavorite ? (
              <em className="icon ni ni-star-fill cm-header__action-btn--active" />
            ) : (
              <em className="icon ni ni-star" />
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default CommunicationHeader;
